import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  submitTicketToZendesk,
  uploadFileToZendesk,
} from '@coconut/services/apis/report';

import { types, actions, getFiles } from '@coconut/services/redux/report';
import {
  getUserId,
  getUsername,
  getRole,
  getRegion,
} from '@coconut/services/redux/profile';
import { showAlertBanner } from '@coconut/services/redux/alertBanner';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '@coconut/constants/alertBannerThemes';
import {
  getAnsweredBy,
  getSelectedQuestionID,
} from '@coconut/scenes/Chat/services/redux/selectQuestion';
import { syncUserToZendesk } from '@coconut/services/apis/report';
import { COCONUT } from '@snapask/common-components/constants/nameOfWebProjects';

export function* submitReportFlow(action) {
  const { email, reportMessage: message } = action.payload;
  const userId = yield select(getUserId);
  const userRole = yield select(getRole);
  const region = yield select(getRegion);
  const name = yield select(getUsername);
  const files = yield select(getFiles);
  const { snapask_uid: tutorId } = yield select(getAnsweredBy);
  const chatroomId = yield select(getSelectedQuestionID);

  try {
    const tokens = files.map((file) => file.token);
    const { data: { b2b_email_title: subjectTitle } = {} } = yield call(
      syncUserToZendesk
    );
    yield call(submitTicketToZendesk, {
      name,
      email,
      userId,
      region,
      role: userRole,
      message,
      studentId: userId,
      tokens,
      tutorId,
      chatroomId,
      projectName: COCONUT,
      subjectTitle,
    });
    yield put(actions.submitReportSuccess());
    yield put(
      showAlertBanner({
        message: 'sdk:sdk.report.successMessage',
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    yield put(actions.submitReportFailed(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export function* uploadFileFlow(action) {
  const { file } = action.payload;
  try {
    const uploadedFile = yield call(uploadFileToZendesk, file);
    const newFile = {
      token: uploadedFile.token,
      name: uploadedFile.attachment.file_name,
      size: uploadedFile.attachment.size,
      isUploaded: true,
    };
    yield put(actions.uploadFileSuccess(newFile));
  } catch (err) {
    yield put(actions.uploadFileFailed(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function* () {
  yield all([
    takeLatest(types.SUBMIT_REPORT_REQUEST, submitReportFlow),
    takeLatest(types.UPLOAD_FILE_REQUEST, uploadFileFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/report.js